// packages/shared-hooks/src/lead-tasks/keys.ts
//
// Query-key factory for the LeadTasks aggregate (#1083). `myDay` is keyed
// on the resolved timezone so a tz change spawns a fresh cache slot rather
// than re-bucketing stale data. Mutations on a task invalidate the whole
// `all` prefix because the action moves the row across buckets.
export const leadTasksKeys = {
  all: ['lead-tasks'] as const,
  myDay: (tz: string) => ['lead-tasks', 'my-day', tz] as const,
  // Duplicate-attention queue (#1260). Under the `all` prefix so
  // completing an attention task flushes it alongside My Day.
  attention: () => ['lead-tasks', 'attention'] as const,
  // Per-lead open task list (#1863). Under the `all` prefix so
  // existing invalidateQueries({ queryKey: leadTasksKeys.all }) in
  // create/reschedule/complete already cascades to it.
  byLead: (leadId: string) => ['lead-tasks', 'by-lead', leadId] as const,
  // Per-lead SOFT-CANCELLED task list (#2317 D-3a). Under the `all` prefix so
  // a cancel/reopen that invalidates `leadTasksKeys.all` refreshes it too.
  cancelledByLead: (leadId: string) => ['lead-tasks', 'cancelled', leadId] as const,
};
